module.exports = __webpack_public_path__ + "img/slide4.b22f7c3c.png";